export enum SectionTitle {
  NEUROLOGICAL_EVALUATION = 'Neurological Evaluation',
  GENERAL_INFO = 'General Info',
  PUPILS = 'Pupils',
  PUPIL_REACTION = 'Pupil Reaction',
  LIMB_MOVEMENT = 'Limb Movement',
  COMA_STATUS = 'Coma Status'
}

export enum FormField {
  PROVIDER_NURSE = 'providerNurse',
  LEFT_PUPIL = 'leftPupil',
  RIGHT_PUPIL = 'rightPupil',
  LEFT_PUPIL_SIZE = 'leftPupilSize',
  RIGHT_PUPIL_SIZE = 'rightPupilSize',
  LEFT_PUPIL_REACTION = 'leftPupilReaction',
  RIGHT_PUPIL_REACTION = 'rightPupilReaction',
  ARM_MOVEMENT = 'armMovement',
  LEG_MOVEMENT = 'legMovement',
  COMA_STATUS = 'comaStatus'
}

export enum FormFieldLabel {
  PROVIDER_NURSE = 'Provider / Nurse',
  LEFT_PUPIL = 'Left Pupil',
  RIGHT_PUPIL = 'Right Pupil',
  LEFT_PUPIL_SIZE = 'Left Pupil Size',
  RIGHT_PUPIL_SIZE = 'Right Pupil Size',
  LEFT_PUPIL_REACTION = 'Left Pupil Reaction to Light',
  RIGHT_PUPIL_REACTION = 'Right Pupil Reaction to Light',
  ARM_MOVEMENT = 'Arm Movement',
  LEG_MOVEMENT = 'Leg Movement',
  COMA_STATUS = 'Coma Status'
}

export enum Placeholder {
  PUPIL_SIZE = 'Select size',
  PUPIL_REACTION = 'Select reaction',
  LIMB_MOVEMENT = 'Select movement',
  COMA_STATUS = 'Select status'
}

export enum DropdownAction {
  CLEAR_LABEL = 'Clear',
  CLEAR_OPTION_ID = '__clear__',
  ROUND_LABEL = 'Round'
}
